module.exports = __webpack_public_path__ + "img/CooCooG Pet.227f4527.svg";